import { useContext } from "react";

import { Flex, Text, Image } from "@chakra-ui/react";

import { Section, PageContext } from "mlp-sdk";

const Journey = () => {
  const { page } = useContext(PageContext);
  const pageData = page.data.pageData;
  const { journey_details = [], section_details = {} } =
    pageData.stader_journey;

  return (
    <Section>
      <Flex
        px={{ base: "1rem", lg: 0 }}
        gap={{ base: "2.5rem", lg: "2rem" }}
        flexDir={{ base: "column", lg: "row" }}
      >
        <Text
          as="h2"
          textStyle={{ base: "h3", lg: "h1" }}
          w={{ base: "100%", lg: "380px" }}
          textAlign={{ base: "center", md: "left" }}
        >
          {section_details?.title || ""}
        </Text>
        <Flex
          flexDir="column"
          gap={{ base: "2rem", lg: "56px" }}
          maxW={{ base: "100%", lg: "787px" }}
          px={{ base: "1.5rem", lg: 0 }}
        >
          {journey_details.map((journeyData: any) => {
            return (
              <Flex
                gap={{ base: "1rem", lg: "24px" }}
                key={journeyData.date}
                alignItems="center"
              >
                <Image
                  src={journeyData.icon_key}
                  boxSize={{ base: "40px", lg: "64px" }}
                  alt={`icon`}
                />
                <Flex flexDir="column" gap="8px" textAlign="left">
                  <Text
                    textStyle={{ base: "h5", lg: "h4" }}
                    fontWeight="600 !important"
                  >
                    {journeyData.date}
                  </Text>

                  <div
                    dangerouslySetInnerHTML={{
                      __html: journeyData.description,
                    }}
                    className="journeyDescription"
                  />
                </Flex>
              </Flex>
            );
          })}
        </Flex>
      </Flex>
    </Section>
  );
};

export default Journey;
